import type { CatalogOf } from '../types';
import type { en } from './en';

export const id: CatalogOf<typeof en> = {
  header: {
    brand: 'Doc Assist',
  },
  language: {
    label: 'Bahasa',
  },
  consult: {
    booked: 'Anzu akan berbicara dengan Anda dalam {language}.',
  },
  languages: {
    en: 'Bahasa Inggris',
    id: 'Bahasa Indonesia',
    hi: 'Bahasa Hindi',
    zh: 'Bahasa Mandarin',
  },
  form: {
    title: 'Informasi Pasien',
    sessionActive: 'Sesi Aktif',
    name: {
      label: 'Nama Panggilan',
      placeholder: 'Masukkan nama lengkap pasien',
      required: 'Nama Panggilan wajib diisi',
    },
    dateOfBirth: {
      label: 'Tanggal Lahir',
      placeholder: 'Pilih tanggal lahir',
      required: 'Tanggal Lahir wajib diisi',
      invalid: 'Masukkan tanggal lahir yang valid',
    },
    gender: {
      label: 'Jenis Kelamin Saat Lahir',
      placeholder: 'Pilih jenis kelamin saat lahir',
      male: 'Laki-laki',
      female: 'Perempuan',
      required: 'Jenis Kelamin Saat Lahir wajib diisi',
    },
    mode: {
      label: 'Mode komunikasi yang saya inginkan',
      voice: 'Suara',
      text: 'Teks',
      required: 'Mode komunikasi wajib dipilih',
    },
    start: 'Mulai Sesi Baru',
  },
  conversation: {
    emptyVoice: 'Percakapan Anda akan muncul di sini',
    emptyText: 'Anzu sedang bersiap. Anda dapat mulai mengetik di bawah.',
    typing: 'Anzu sedang mengetik',
    you: 'Anda',
    anzu: 'Anzu',
    placeholder: 'Ketik pesan Anda...',
    send: 'Kirim',
  },
  session: {
    end: 'Akhiri Sesi',
    saving: 'Menyimpan Sesi...',
    confirmBody: 'Apakah Anda yakin ingin mengakhiri sesi ini? Tindakan ini tidak dapat dibatalkan.',
    continue: 'Lanjutkan Sesi',
  },
  timeout: {
    title: 'Peringatan Waktu Sesi Habis',
    inactive: 'Sesi Anda tidak aktif selama 60 detik.',
    countdown: 'Sesi Anda akan berakhir otomatis dalam {seconds} detik.',
    hint: 'Klik "Lanjutkan Sesi" untuk melanjutkan, atau biarkan sesi berakhir otomatis.',
    endNow: 'Akhiri Sekarang',
  },
  errors: {
    micPermission: 'Anzu memerlukan mikrofon Anda untuk melakukan percakapan suara. Izinkan akses mikrofon di browser Anda dan buka tautan ini lagi, atau mulai ulang dan pilih mode teks.',
  },
  disclaimer: {
    title: 'Penafian Umum Platform AIGP Health',
    important: 'PENTING: HARAP BACA PENAFIAN INI DENGAN SAKSAMA SEBELUM MENGGUNAKAN PLATFORM AIGP HEALTH.',
    lead: 'Dengan menggunakan platform AI AIGP Health "Anzu", pengguna mengakui dan menyetujui hal-hal berikut:',
    point1: 'Platform ini menggunakan kecerdasan buatan (AI) untuk mengumpulkan informasi Anda.',
    point2: 'Informasi yang dimasukkan ke dalam sistem AI akan diteruskan kepada dokter yang merawat Anda pada saat konsultasi terjadwal Anda.',
    point3: 'Informasi tersebut tidak akan diakses, ditinjau, atau ditindaklanjuti oleh dokter mana pun sebelum janji temu Anda.',
    point4: 'Platform ini tidak ditujukan untuk digunakan dalam keadaan darurat medis.',
    point5: 'Jika Anda mengalami nyeri dada, kesulitan bernapas, pendarahan hebat, atau kondisi serius atau mengancam jiwa lainnya, akhiri sesi sekarang dan segera hubungi 000.',
    point6: 'Jika kondisi Anda memburuk setelah menyelesaikan sesi prakonsultasi ini, Anda setuju untuk mencari perawatan medis darurat atau menghubungi rumah sakit setempat.',
    point7: 'Dengan terus menggunakan platform ini, Anda menegaskan bahwa ini bukan keadaan darurat medis dan bahwa Anda memahami Anzu hanyalah alat prakonsultasi.',
    point8: 'AIGP Health tidak bertanggung jawab atas akibat yang timbul dari keterlambatan perawatan ketika penanganan darurat diperlukan.',
    cancel: 'Batal',
    agree: 'Saya Setuju - Mulai Sesi',
  },
  farewell: {
    preparing: 'Menyiapkan ringkasan Anda...',
    preparingHint: 'Ini hanya memerlukan waktu sebentar.',
    thanks: 'Terima kasih telah menggunakan AIGP Health Doc Assist',
    loggingOut: 'Keluar...',
  },
};
